var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M15.883 24.142l.124-.137a1.747 1.747 0 012.457 0L24 29.478l5.536-5.473a1.747 1.747 0 012.333-.112l.138.126c.624.632.655 1.627.097 2.295l-.111.12-6.634 6.561c-.374.37-.872.536-1.358.5a1.744 1.744 0 01-1.36-.5l-6.634-6.56a1.709 1.709 0 01-.124-2.293zm0-8l.124-.137a1.747 1.747 0 012.457 0L24 21.478l5.536-5.473a1.747 1.747 0 012.333-.112l.138.126c.624.632.655 1.627.097 2.295l-.111.12-6.634 6.561c-.374.37-.872.536-1.358.5a1.744 1.744 0 01-1.36-.5l-6.634-6.56a1.709 1.709 0 01-.124-2.293z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
